import React from 'react';

import { DatePickerChange } from '@tag/tag-components-react-v4';

import Skeleton from '../Skeleton/Skeleton';


import styles from './contract-header.module.scss';
import DatePickerTag4 from '../DatePicker/DatePickerTag4';


interface IContractHeaderDatePickerItemProps {
  label: string,
  value?: Date;
  defaultValue?: Date;
  isLoading?: boolean,
  disabled: boolean,
  name?: string
  onChange?: ((e: DatePickerChange) => void),
  clearButton?: boolean;
  labelSuffix?: React.ReactNode;
}


export default function ContractHeaderDatePickerItem({
  label,
  value,
  defaultValue,
  isLoading,
  disabled,
  name,
  onChange,
  clearButton,
  labelSuffix,
}: IContractHeaderDatePickerItemProps): JSX.Element {

  return (
    <div
      className={styles['contract-header']}
    >
      <span className={styles.label}>{label}{labelSuffix}</span>
      {isLoading ? (
        <Skeleton
          count={1}
        />
      ) : (<div>
        <DatePickerTag4
          inputStyle={{ width: '100%' }}
          disabled={disabled}
          name={name}
          onChange={onChange}
          value={value}
          defaultValue={defaultValue}
          clearButton={clearButton}
        />
      </div>)}
    </div>
  );
}
